import { Checkbox, Link, type CheckboxProps } from "@mui/material";
import { useId, useState } from "react";
import { useTranslations } from "use-intl";

import { MoreDetailsDrawer } from "@/components/MoreDetailsDrawer/MoreDetailsDrawer";

type Props = Pick<CheckboxProps, "checked" | "onChange" | "onBlur">;

export function TermsAndConditionsCard({ checked, onBlur, onChange }: Props) {
  const t = useTranslations();
  const checkboxId = useId();
  const [moreDetailsOpen, setMoreDetailsOpen] = useState(false);

  return (
    <>
      <div className="flex rounded-3xl bg-white p-3">
        <div className="flex gap-2 text-sm">
          <div className="shrink-0">
            <Checkbox
              id={checkboxId}
              checked={checked}
              onChange={onChange}
              onBlur={onBlur}
              sx={{ p: 0 }}
            />
          </div>

          <div className="flex flex-col gap-1 pt-1">
            <label
              className="text-sm font-semibold text-text-primary"
              htmlFor={checkboxId}
            >
              {t("flights.acceptGeneralTerms")}
            </label>
            <div className="text-sm text-text-tertiary">
              {t("flights.acceptGeneralTermsWarning")}
            </div>
            <Link
              onClick={() => setMoreDetailsOpen(true)}
              sx={{ fontSize: "14px" }}
            >
              {t("moreDetails")}
            </Link>
          </div>
        </div>
      </div>

      <MoreDetailsDrawer
        open={moreDetailsOpen}
        onClose={() => setMoreDetailsOpen(false)}
      />
    </>
  );
}
